module.exports = {"420881001":"郢中街道","420881100":"洋梓镇","420881101":"长寿镇","420881102":"丰乐镇","420881103":"胡集镇","420881104":"双河镇","420881105":"磷矿镇","420881106":"文集镇","420881107":"冷水镇","420881108":"石牌镇","420881109":"旧口镇","420881110":"柴湖镇","420881111":"长滩镇","420881112":"东桥镇","420881113":"客店镇","420881114":"张集镇","420881200":"九里乡","420881400":"湖北钟祥经济开发区","420881450":"钟祥市官庄湖管理区","420881451":"南湖原种场","420881452":"罗汉寺种畜场","420881453":"双桥原种场","420881454":"东岳种畜场","420881455":"康桥湖农场","420881456":"大口林场","420881457":"盘石岭林场","420881458":"温峡水库","420881459":"石门水库","420881460":"黄坡水库","420881461":"湖北钟祥胡集经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420881.json
// module id = 1877
// module chunks = 0